// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__jRfNq","title":"BackImages_title__1jCEF","images":"BackImages_images__kW1IV"};